function getStoredTheme() {
  return localStorage.getItem('theme');
}

function setStoredTheme(theme) {
  localStorage.setItem('theme', theme);
}

function getPreferredTheme() {
  const storedTheme = getStoredTheme();
  if (storedTheme) {
    return storedTheme;
  }

  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function setTheme(theme) {
  if (theme === 'auto') {
    document.documentElement.setAttribute('data-bs-theme', (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'));
  } else {
    document.documentElement.setAttribute('data-bs-theme', theme);
  }
}

setTheme(getPreferredTheme());

function showActiveTheme(theme, focus = false) {
  const themeSwitcher = document.querySelector('#luv-theme');

  if (!themeSwitcher) {
    return;
  }

  const themeSwitcherText = document.querySelector('#luv-theme-text');
  const activeThemeIcon = document.querySelector('.theme-icon-active');
  const btnToActive = document.querySelector(`[data-bs-theme-value="${theme}"]`);
  const iconOfActiveBtn = btnToActive.querySelector('i');
  document.querySelectorAll('[data-bs-theme-value]').forEach((element) => {
    element.classList.remove('active');
    element.setAttribute('aria-pressed', 'false');
  });

  btnToActive.classList.add('active');
  btnToActive.setAttribute('aria-pressed', 'true');
  const selectedClasses = Array.from(iconOfActiveBtn.classList.values());
  const iconClass = selectedClasses.find((element) => element.startsWith('bi-'));
  activeThemeIcon.className = `theme-icon-active ${iconClass}`;
  const themeSwitcherLabel = `${themeSwitcherText.textContent} (${btnToActive.dataset.bsThemeValue})`;
  themeSwitcher.setAttribute('aria-label', themeSwitcherLabel);

  if (focus) {
    themeSwitcher.focus();
  }
}

export default function base() {
  // Remove cookie and button if clicked
  const ldapButton = document.getElementById('logout-ldap');
  if (ldapButton) {
    ldapButton.addEventListener(
      'click',
      (event) => {
        document.cookie = 'ipa_session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict';
        event.target.remove();
      },
      false,
    );
  }

  document.addEventListener('wheel', () => {
    if (document.activeElement.type === 'number') {
      document.activeElement.blur();
    }
  });
  document.querySelectorAll(
    'select:not(.selectmultiple)',
  ).forEach((element) => element.classList.add('custom-select'));

  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    const storedTheme = getStoredTheme();
    if (storedTheme !== 'light' && storedTheme !== 'dark') {
      setTheme(getPreferredTheme());
    }
  });

  showActiveTheme(getPreferredTheme());

  document.querySelectorAll('[data-bs-theme-value]')
    .forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const theme = toggle.getAttribute('data-bs-theme-value');
        setStoredTheme(theme);
        setTheme(theme);
        showActiveTheme(theme, true);
      });
    });

  /* eslint-disable */

  var _paq = window._paq = window._paq || [];
  /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
  _paq.push(['trackPageView']);
  _paq.push(['enableLinkTracking']);
  (function() {
    var u="https://matomo.dkrz.de/";
    _paq.push(['setTrackerUrl', u+'matomo.php']);
    _paq.push(['setSiteId', '7']);
    var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
    g.type='text/javascript'; g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
  })();

  /* eslint-disable */
}
